<template>
    <div class="start-view view" :style="bodyStyles">
        <div class="wrapper">
            <div class="splash-logo">
                <a :href="configuration.homePageLink ?? '/'">
                    <img src="../../less/img/logo.png" />
                </a>
            </div>

            <a href="#" class="languages" @click.prevent.stop="ui.languagesVisible = !ui.languagesVisible" v-if="ui.languages.length > 0 && !state.proshop">
                <span class="icon-globe"></span>
                <span class="title">{{ ui.language }}</span>

                <div class="language-list" v-show="ui.languagesVisible">
                    <a href="#" @click.prevent.stop="changeLanguage(language)" v-for="language in ui.languages" :key="language">
                        {{ language  }}
                    </a>
                </div>
            </a>

            <h2 class="h2" v-html="ui.texts.frontpageMain.title"></h2>

            <div class="highlight-text">
                <div class="text" v-html="ui.texts.frontpageMain.text"></div>
            </div>

            <label class="form-group highlights">
                <div class="image-group">
                    <a v-for="block in ui.blocks.startHighlights" :key="block" :href="block.link" class="list-group-item col-4">
                        <div class="container">
                            <div class="image" :style="{ 'background-image': ui.getBackgroundImageUrl(block.images[0], 600)! }"></div>

                            <h3>
                                {{ block.title }}
                            </h3>
                        </div>
                    </a>
                </div>
            </label>

            <div class="enter-code col-8">
                <h2 class="h2" v-html="ui.t('frontpageUseCode')"></h2>

                <label class="form-group plan-code">
                    <div class="row">
                        <div class="col-9">
                            <span class="input-tip" v-if="message" v-html="message"></span>
                            <input type="text" @keyup.enter="setDesignerCode" v-model="designerCode" class="form-control" />
                        </div>
                        <div class="col-3">
                            <a href="" @click.prevent="setDesignerCode" v-html="ui.t('frontpageUseCodeButton')" class="button-link"></a>
                        </div>
                    </div>
                </label>
            </div>

            <div class="banner col-8" v-if="ui.texts.frontpageBannerContent.images">
                <a :href="ui.texts.frontpageBannerContent.link" v-if="ui.texts.frontpageBannerContent.link" target="_blank">
                    <img :src="ui.texts.frontpageBannerContent.images[0]" />
                </a>

                <img :src="ui.texts.frontpageBannerContent.images[0]" v-if="!ui.texts.frontpageBannerContent.link" />

                <div class="text" v-html="ui.texts.frontpageBannerContent.text"></div>
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { computed, ref, type Ref } from 'vue';
import { useCart, useConfiguration, useState, useUI } from '../store';
import { useRoute, useRouter } from 'vue-router';

const emit = defineEmits(["language-changed"]);

const designerCode = ref("");
const message: Ref<string | null> = ref("");
let messageTimeout: number | null = null;

const { state } = useState();
const { ui } = useUI();
const { cart } = useCart();
const { configuration } = useConfiguration();
const router = useRouter();
const route = useRoute();

function mounted() {
    state.mode = "worktop";

    if (state.externalEmbed)
        router.push("/worktop");

    // if (route.params.family) {
    //     router.
    // }
}

function changeLanguage(code: string) {
    emit("language-changed", code);
}

const bodyStyles = computed(() => {
    return {
        "background-image": "url('" + ui.texts.frontpageMain.images[0] + "')"
    }
});

async function setDesignerCode() {
    clearTimeout(messageTimeout!);

    let code = designerCode.value.toUpperCase();

    if (code == "T") {
        await testData();

        return;
    }

    await cart.setDesignerCode(code);

    if (cart.isCurrentCodeValidWorktopCode) {
        message.value = null;

        state.mode = "worktop";
        router.push({ name: "Summary"});
    }
    else if (cart.isCurrentCodeValidBackpanelCode) {
        message.value = null;

        state.mode = "backpanel";
        router.push({ name: "Summary" });
    }
    else {
        message.value = ui.t("invalidDesignerCode");

        messageTimeout = setTimeout(() => { message.value = null }, 3000);
    }
}

async function testData() {
    await cart.setDesignerCode("PLAN-000066");

    router.replace("/sink");
}

mounted();
</script>
